import React from 'react'
import { useIntl } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { formatCoveringProviderComposerNotice } from '@lyrahealth-inc/shared-app-logic/src/features/messaging/coveringProviderAttribution'
import { InlineInfoBanner } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/inlineInfoBanner/InlineInfoBanner'

type SupervisorMessageAttributionNoticeProps = {
  actorName: string
}

export const SupervisorMessageAttributionNotice = ({ actorName }: SupervisorMessageAttributionNoticeProps) => {
  const intl = useIntl()
  const { colors, spacing } = useTheme()

  return (
    <InlineInfoBanner
      testId='SupervisorMessageAttributionNotice'
      backgroundColor={colors.backgroundElement}
      textColor={colors.textSecondary}
      iconColor={colors.iconDefault}
      marginBottom={spacing['16px']}
      iconSize={16}
      text={formatCoveringProviderComposerNotice(intl, actorName)}
    />
  )
}
